import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkApi } from '../../store'
import { WithRedirectBack } from '.'
import { enqueueErrorSnackbar, enqueueSuccessSnackbar } from './notificationActions'
import { AdPod, AdPodInit, AdPodUpdate } from 'common/api/v1/types'
import { AdPodsRequestParams } from '../../api/nm-types'
import { ListResult } from 'common/api/v1/types'

export const listAdPods = createAsyncThunk<ListResult<AdPod>, AdPodsRequestParams, ThunkApi>(
  'adPods/listAdPods',
  async (params, { dispatch, extra: { api } }) => {
    try {
      return await api.adPodsApi.listAdPods(params)
    } catch (error) {
      dispatch(enqueueErrorSnackbar({ error, operation: 'fetch Ad Pods' }))
      throw error
    }
  },
)

export const getAdPod = createAsyncThunk<AdPod, string, ThunkApi>(
  'adPods/getAdPod',
  async (id, { dispatch, extra: { api } }) => {
    try {
      return await api.adPodsApi.getAdPod(id)
    } catch (error) {
      dispatch(enqueueErrorSnackbar({ error, operation: 'fetch Ad Pod' }))
      throw error
    }
  },
)

export const createAdPod = createAsyncThunk<AdPod, AdPodInit, ThunkApi>(
  'adPods/createAdPod',
  async (adPodInit, { dispatch, extra: { routes, api, navigate } }) => {
    try {
      const res = await api.adPodsApi.createAdPod(adPodInit)
      navigate()(routes.adPods())
      dispatch(enqueueSuccessSnackbar('Ad Pod created'))
      return res
    } catch (error) {
      dispatch(enqueueErrorSnackbar({ error, operation: 'create Ad Pod' }))
      throw error
    }
  },
)

export const updateAdPod = createAsyncThunk<AdPod, AdPodUpdate, ThunkApi>(
  'adPods/updateAdPod',
  async (adPod, { dispatch, extra: { routes, api, navigate } }) => {
    try {
      const res = await api.adPodsApi.updateAdPod(adPod.id, adPod)
      navigate()(routes.adPods())
      dispatch(enqueueSuccessSnackbar('Ad Pod saved'))
      return res
    } catch (error) {
      dispatch(enqueueErrorSnackbar({ error, operation: 'update Ad Pod' }))
      throw error
    }
  },
)

export const deleteAdPod = createAsyncThunk<AdPod, { id: string } & WithRedirectBack, ThunkApi>(
  'adPods/deleteAdPod',
  async ({ id, redirect }, { dispatch, extra: { api, routes, navigate } }) => {
    try {
      const res = await api.adPodsApi.deleteAdPod(id)
      redirect && navigate()(routes.adPods())
      dispatch(enqueueSuccessSnackbar('Ad Pod deleted'))
      return res
    } catch (error) {
      dispatch(enqueueErrorSnackbar({ error, operation: 'delete Ad Pod' }))
      throw error
    }
  },
)

export const deleteAdPods = createAsyncThunk<string[], string[], ThunkApi>(
  'adPods/deleteAdPods',
  async (ids, { dispatch, extra: { api } }) => {
    try {
      for (const id of ids) {
        await api.adPodsApi.deleteAdPod(id)
      }
      dispatch(enqueueSuccessSnackbar('Ad Pod deleted'))
      return ids
    } catch (error) {
      dispatch(enqueueErrorSnackbar({ error, operation: 'delete Ad Pod' }))
      throw error
    }
  },
)

export const clearAdPod = createAction('adPods/clearAdPod')
export const clearAdPods = createAction('adPods/clearAdPods')
